import React from 'react';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import toNumber from 'lodash/toNumber';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

import DateIntervalPicker from '../Forms/DateIntervalPicker';
import SimpleTable from './SimpleTable';
import {makeTableData} from './utils';
import useStyles from './styles';

const View = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  onRowClick,
  data,
  isBusy,
}) => <Grid container justify='center'>
  <Grid item xs={12}>
    <SlotsHeader
      {...{startDate, setStartDate, endDate, setEndDate}}
    />
  </Grid>
  <Grid item xs={12}>
    <SlotsTable {...{isBusy, onRowClick, data}} />
  </Grid>
</Grid>;

export const SlotsTable = ({
  data,
  onRowClick,
  isBusy,
}) => {

  const classes = useStyles();

  const makeIdNumeric = data => map(data, el => ({...el, id: toNumber(el._id)}));
  const listData = makeTableData(makeIdNumeric(data));

  const tableColumns = [
    // { width: 170, flexGrow: 1, label: 'Id', dataKey: '_id', numeric: true },
    { width: 200 , flexGrow: 1 , label: 'Integrado'     , dataKey: 'member'     , sortKey: 'member'     , numeric: true }  ,
    { width: 130 , flexGrow: 1 , label: 'Valor (R$)'    , dataKey: 'valueT'     , sortKey: 'value'      , numeric: true }  ,
    { width: 110 , flexGrow: 1 , label: 'Peso (Kg)'     , dataKey: 'weight'     , sortKey: 'weight'     , numeric: true }  ,
    { width: 130 , flexGrow: 1 , label: 'Distâcia (Km)' , dataKey: 'distance'   , sortKey: 'distance'   , numeric: true }  ,
    { width: 100 , flexGrow: 1 , label: 'Caçambas'      , dataKey: 'slotNumber' , sortKey: 'slotNumber' , numeric: true }  ,
    { width: 100 , flexGrow: 0 , label: 'Idade Atual'   , dataKey: 'age'        , sortKey: 'age'        , numeric: true }  ,
    { width: 100 , flexGrow: 0 , label: 'Tipo'          , dataKey: 'slotTypeT'  , sortKey: 'slotTypeT'  , numeric: false } ,
    { width: 100 , flexGrow: 0 , label: 'Status'        , dataKey: 'statusT'    , sortKey: 'statusT'    , numeric: false } ,
    { width: 200 , flexGrow: 1 , label: 'Atualização'   , dataKey: 'updateT'    , sortKey: 'validFrom'  , numeric: true }  ,
  ];

  return isBusy
    ? <Grid container xs={12} justify='center'>
      <CircularProgress className={classes.spinner}/>
    </Grid>
    : !isEmpty(listData)
    ? <Grid container direction='column' className={classes.deliveriesContainer}>
      <SimpleTable
        rowCount={listData.length}
        list={listData}
        rowHeight={78}
        onRowClick={onRowClick}
        columns={tableColumns}
      />
    </Grid>
    : <Grid container xs={12} justify='center'>
      <Typography variant='h6' className={classes.title}>
        Nenhum item encontrado...
      </Typography>
    </Grid>;
};

export const SlotsHeader = ({
  startDate,
  endDate,
  setStartDate,
  setEndDate
}) => {

  const classes = useStyles();

  return <Grid
    container
    justify='center'
    alignItems='center'
    className={classes.header}
  >
    <Grid item xs={12}>
      <Typography variant='h6' className={classes.title}>
        Entregas
      </Typography>
    </Grid>
    <Grid item xs={12}>
      <DateIntervalPicker
        {...{startDate, setStartDate, endDate, setEndDate}}
      />
    </Grid>
  </Grid>;
};

export default View;
